module.exports = __webpack_public_path__ + "static/media/Figma_Design_Constr.e9a476c8.png";